/**
 * MAP (in-file navigation graph — any LLM reads this without external tooling;
 * keep in sync with the code):
 *   role:      component — «UI nuova» fork of SlideProdotti (M18 ec-catalog):
 *              the popular-products rail; template only, the class adds nothing
 *   extends:   SlideProdottiComponent
 *   template:  rail.hbs
 *   args:      @products, @applicationController
 *   uses:      -
 *   siblings:  components/slide-prodotti.js (the classic it extends),
 *              ec-catalog-nuova/tile.hbs (one product)
 *   tests:     ui-nuova-ec-catalog-test.js
 *   gotchas:   sideScroll finds the rail by the inherited guidFor slideId, so
 *              the template must keep `id='{{this.slideId}}'` on the scroller.
 *
 * Rendered by ec-catalog-nuova/index-page.hbs and list-page.hbs (empty state).
 */
import SlideProdottiComponent from '../slide-prodotti';

export default class EcCatalogNuovaRailComponent extends SlideProdottiComponent {}
